import { render } from "./wage-money-dynamic-salary.vue?vue&type=template&id=754d2a72"
import script from "./wage-money-dynamic-salary.vue?vue&type=script&lang=js"
export * from "./wage-money-dynamic-salary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/wagesetting/wage-money-dynamic-salary.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "754d2a72"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('754d2a72', __exports__)) {
    api.reload('754d2a72', __exports__)
  }
  
  module.hot.accept("./wage-money-dynamic-salary.vue?vue&type=template&id=754d2a72", () => {
    api.rerender('754d2a72', render)
  })

}


export default __exports__